import app from '../app';

app.directive('customOnChange', () => {
  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      const onChangeFunc = scope.$eval(attrs.customOnChange);

      element.bind('change', onChangeFunc);
    }
  };
});
